<template>
    <Page header="Авторизация" type="" :nopadding="false" header_pos="left">
        <template #body>
            <AuthForm />
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import AuthForm from '@/components/personal/auth_form.vue'
import Page from '@/components/public/page.vue'

export default {
    data() {
        return {
            loading: false,
            list: null,
        }
    },
    components: {
        AuthForm,
        Page
    },
    methods: {
       
    },
    async mounted() {
       
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>